import { render } from "./TheSheetMenuHeader.vue?vue&type=template&id=0e0223f6&scoped=true"
import script from "./TheSheetMenuHeader.vue?vue&type=script&lang=js"
export * from "./TheSheetMenuHeader.vue?vue&type=script&lang=js"

import "./TheSheetMenuHeader.vue?vue&type=style&index=0&id=0e0223f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e0223f6"

export default script